import Api from '/core/services/Api';

export const fetchLeagues = async() => {
    try {
        const response = await Api.get(`leagues`);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const fetchOneLeagueDraws= async(i) => {
    try {
        const response = await Api.get(`leagues/`+i);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}

export const fetchOneMultiLeagueDraws= async(i) => {
    try {
        const response = await Api.get(`leagues-multi/`+i);

        return response;
    } catch (error) {
        return Api.technicalError();
    }
}